import VehicleService from '@allesauto/design/svg/vehicle-services.svg';
import {
  Aperture32,
  BatteryCharging32,
  Car32,
  Snowflake32,
  Umbrella32,
} from '@carbon/icons-react';
import React, { FC } from 'react';

export type CategoryNameType =
  | 'Inspection'
  | 'TiresWheels'
  | 'BatteryTank'
  | 'VehicleDamage'
  | 'Accessories'
  | 'AirConditioning';

const categoryNameIcons = {
  Inspection: Car32,
  TiresWheels: Aperture32,
  BatteryTank: BatteryCharging32,
  AirConditioning: Snowflake32,
  Accessories: Umbrella32,
  VehicleDamage: VehicleService,
};

interface CategoryNameIconProps {
  categoryName: CategoryNameType;
}

const CategoryNameIcon: FC<CategoryNameIconProps> = (props) => {
  const { categoryName } = props;

  const CategoryIcon = categoryName && categoryNameIcons[categoryName];
  return (
    <div className="sm:h-[60px] sm:w-[60px] md:h-[80px] md:w-[80px]">
      {CategoryIcon && <CategoryIcon className="h-full w-full" />}
    </div>
  );
};

export default CategoryNameIcon;
